// extracted by mini-css-extract-plugin
export var md = "_52-4";
export var semantic = "_52-5";
export var sm = "_52-3";
export var text = "_52-6";
export var toggleInput = "_52-0";
export var toggleSwitch = "_52-1";
export var xs = "_52-2";